import React from 'react';

import { InlineNodeRendererWrapper } from '@atlaskit/renderer';

import { useRenderServerPlaceholder } from '@confluence/ssr-utilities/entry-points/useRenderServerPlaceholder';

/**
 * Split out this component because createMacroExtensionHandler is not a React component
 */
export function PlaceholderAwareInlineNodeRendererWrapper({
	children,
	macroId,
}: {
	children: React.ReactNode;
	macroId: string;
}) {
	const renderServerPlaceholder = useRenderServerPlaceholder();

	return (
		<InlineNodeRendererWrapper
			{...(renderServerPlaceholder
				? { ssrPlaceholder: macroId }
				: { ssrPlaceholderReplace: macroId })}
		>
			{children}
		</InlineNodeRendererWrapper>
	);
}
